<template>
  <button
    type="button"
    :aria-label="label"
    :disabled="disabled"
    :class="{
      'opacity-40': disabled,
      'items-center': !hasSubHeading,
    }"
    class="flex flex-row w-full space-x-4 hover:opacity-70"
    @click="$emit('click', $event)"
  >
    <span
      v-if="icon.length"
      class="size-7 content-end"
    >
      <fa
        :icon="icon"
        class="text-neutral-900 text-xl"
      />
    </span>
    <span class="flex-1 text-left">
      <span class="flex flex-col">
        <span class="flex flex-row items-center justify-start space-x-2">
          <slot name="heading" />
          <vetster-outline-badge
            v-if="badge"
            :class="badgeClasses"
            :color="badgeVariant"
          >
            <template #label>
              {{ badge }}
            </template>
          </vetster-outline-badge>
        </span>
        <slot name="sub-heading" />
      </span>
    </span>
    <span class="size-7 content-end">
      <fa
        v-if="rightIcon.length"
        :icon="rightIcon"
        class="text-neutral-900 text-xl"
      />
    </span>
  </button>
</template>

<script>
import VetsterOutlineBadge from '@/brand-components/VetsterOutlineBadge';

export default {
  name: 'VetsterNavItem',

  components: { VetsterOutlineBadge },

  props: {
    badge: {
      type: String,
      default: null,
    },
    badgeClasses: {
      type: String,
      default: '',
    },
    badgeVariant: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    rightIcon: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['click'],

  computed: {
    hasSubHeading() {
      return !!this.$slots['sub-heading'];
    },
  },
};
</script>
